import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const Container = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 2rem 0;
`;
